// extracted by mini-css-extract-plugin
export default {"bottom-squares":"Squares_bottom-squares__PBn3e","top-squares":"Squares_top-squares__P9HBI","square":"Squares_square__H1zRb"};